import React from 'react';

export default function DriverSpecialNeedsCard({ embedded = false }) {
  const instructions = [
    {
      bold: "Keep both hands on the wheel.",
      rest: "Don't move them until the officer says it's okay.",
      isRed: false
    },
    {
      bold: "Expect bright lights and sounds.",
      rest: "The officer's car will have flashing lights. They may use a flashlight and radio.",
      isRed: false
    },
    {
      bold: "Say you have this envelope.",
      rest: 'Tell the officer right away: "I have a communication card for you."',
      isRed: false
    },
    {
      bold: "Ask before you move.",
      rest: 'Say "Can I reach for my wallet?" Wait for the officer to say yes.',
      isRed: false
    },
    {
      bold: "Move slowly.",
      rest: "Get your envelope carefully and hand it to the officer.",
      isRed: false
    },
    {
      bold: "The officer will read your card.",
      rest: "They will take it to their car to read the information inside.",
      isRed: false
    },
    {
      bold: "STAY IN YOUR CAR.",
      rest: "Do not drive away. Do not get out. Wait for the officer.",
      isRed: true
    },
    {
      bold: "The officer will come back.",
      rest: "They will return your envelope to you.",
      isRed: false
    },
    {
      bold: "Wait to be told you can leave.",
      rest: "The officer will say when you can go.",
      isRed: false
    }
  ];

  const wrapperClass = embedded
    ? 'w-full'
    : 'min-h-screen bg-gray-100 flex items-center justify-center p-4';
  const innerClass = embedded
    ? 'bg-sky-100 rounded p-2 w-full'
    : 'bg-sky-100 rounded-lg p-4 max-w-3xl w-full shadow-lg';
  const cardClass = embedded
    ? 'bg-white border-2 border-blue-700 rounded p-3'
    : 'bg-white border-2 border-blue-700 rounded p-6';
  const titleClass = embedded
    ? 'text-center text-xl font-bold text-blue-600 mb-2'
    : 'text-center text-3xl font-bold text-blue-600 mb-6';
  const subtitleClass = embedded ? 'mb-2 text-sm' : 'mb-4';
  const listSpacing = embedded ? 'space-y-1' : 'space-y-3';
  const itemTextClass = embedded ? 'text-gray-800 text-xs' : 'text-gray-800 text-lg';
  const checkClass = embedded ? 'text-blue-600 font-bold text-sm mt-0.5' : 'text-blue-600 font-bold text-lg mt-0.5';
  const accentBarClass = embedded ? 'h-1 bg-yellow-400 mt-2 rounded-b' : 'h-2 bg-yellow-400 mt-4 rounded-b';

  return (
    <div className={wrapperClass}>
      <div className={innerClass}>
        <div className={cardClass}>
          {/* Title */}
          <h1 className={titleClass}>
            DRIVER WITH SPECIAL NEEDS
          </h1>
          
          {/* Subtitle */}
          <p className={subtitleClass}>
            <span className="font-bold text-gray-900">DRIVER'S INSTRUCTIONS:</span>
            <span className="font-bold text-gray-700 ml-2">(LAW ENFORCEMENT INSTRUCTIONS ON THE OTHER SIDE)</span>
          </p>
          
          {/* Instructions List */}
          <div className={listSpacing}>
            {instructions.map((instruction, index) => (
              <div key={index} className="flex items-start gap-2">
                <span className={`${checkClass} flex-shrink-0`}>✓</span>
                <p className={itemTextClass}>
                  <span className={`font-bold ${instruction.isRed ? 'text-red-600' : 'text-gray-900'}`}>
                    {instruction.bold}
                  </span>
                  {' '}{instruction.rest}
                </p>
              </div>
            ))}
          </div>
        </div>
        
      </div>
    </div>
  );
}